.segment {
  max-width: 300px;
}

.item:not(:is(:empty, :last-child)) {
  align-self: stretch;
  border-right: 1px solid var(--paletteNeutral0);
  padding-right: var(--spacingMd);
  margin-right: var(--spacingMd);
}
